









































import { Component, Vue, Prop } from 'vue-property-decorator';
import { JobServiceForm } from '@/models/jobServiceForm/jobServiceForm';
import { JobServiceFormRequest } from '@/models/jobServiceForm/jobServiceFormRequest';
import { SignatureRequest } from '@/models/jobServiceForm/signatureRequest';
import SignOffField from '@/components/jobServiceForm/SignOffField.vue';
import Nullable from '@/types/nullable';
import { vxm } from '@/stores';

@Component({
  components: {
    SignOffField
  }
})
export default class JobServiceFormEdit extends Vue {
  @Prop({ type: Object, default: null }) public data!: JobServiceFormRequest;
  @Prop({ type: Object, default: null }) public loadedForm!: Nullable<JobServiceForm>;
  private expanded: boolean = false;

  get clientSignatureSignedAt(){
    if(this.data.clientJobCompleteSignOff != null){
      return this.data.clientJobCompleteSignOff.signedAt;
    }
    
    if(this.loadedForm != null && this.loadedForm.clientJobCompleteSignOff != null){
      return this.loadedForm.clientJobCompleteSignOff.signedAt;
    }

    return null;
  }

  get clientSignatureSignedAs(){
    if(this.data.clientJobCompleteSignOff != null){
      return this.data.clientJobCompleteSignOff.signedAs;
    }

    if(this.loadedForm != null && this.loadedForm.clientJobCompleteSignOff != null){
      return this.loadedForm.clientJobCompleteSignOff.signedAs;
    }

    return null;
  }

  get clientSignatureUri(){
    if(this.data.clientJobCompleteSignOff != null){
      return this.data.clientJobCompleteSignOff.base64;
    }

    if(this.loadedForm != null && this.loadedForm.clientJobCompleteSignOff != null){
      return this.loadedForm.clientJobCompleteSignOff.uri;
    }

    return null;
  }

  get loggedInUser(){
    return vxm.user.id
  }

  get technicianSignatureSignedAt(){
    if(this.data.technicianJobCompleteSignOff != null){
      return this.data.technicianJobCompleteSignOff.signedAt;
    }

    if(this.loadedForm != null && this.loadedForm.technicianJobCompleteSignOffs != null){
      let technicianSignOff = this.loadedForm.technicianJobCompleteSignOffs.find(x => x.technician.id === this.loggedInUser);
      if(technicianSignOff != null){
        return technicianSignOff.signedAt;
      }
    }

    return null;
  }

  get technicianSignatureSignedAs(){
    if(this.data.technicianJobCompleteSignOff != null){
      return this.data.technicianJobCompleteSignOff.signedAs;
    }

    if(this.loadedForm != null && this.loadedForm.technicianJobCompleteSignOffs != null){
      let technicianSignOff = this.loadedForm.technicianJobCompleteSignOffs.find(x => x.technician.id === this.loggedInUser);
      if(technicianSignOff != null){
        return technicianSignOff.signedAs;
      }
    }

    return null;
  }

  get technicianSignatureUri(){
    if(this.data.technicianJobCompleteSignOff != null){
      return this.data.technicianJobCompleteSignOff.base64;
    }

    if(this.loadedForm != null && this.loadedForm.technicianJobCompleteSignOffs != null){
      let technicianSignOff = this.loadedForm.technicianJobCompleteSignOffs.find(x => x.technician.id === this.loggedInUser);
      if(technicianSignOff != null){
        return technicianSignOff.uri;
      }
    }

    return null;
  }

  updateTechnicianJobCompleteSignOff(signOff: SignatureRequest){
    this.data.technicianJobCompleteSignOff = signOff;
  }

  get otherTechnicianSignOffs(){
    if(this.loadedForm != null && this.loadedForm.technicianJobCompleteSignOffs != null){
      return this.loadedForm.technicianJobCompleteSignOffs.filter(x => x.technician.id !== this.loggedInUser);
    }
    
    return [];
  }
}

